import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The sixth photo",
  "description": "",
  "published": "2009-03-02T00:00:00.000Z",
  "redirect_from": ["/blog/the-sixth-photo/swizec/3"],
  "categories": "funny",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Another month, another online tagging meme and since I skipped the 23 things on facebook and another few I've decided to play along this time since @freeeky thinks I'm a good target for these things. Fine.`}</p>
    <p>{`Apparently the gist of the matter is going into your albums collection and upload the sixth image from the sixth album ... why they didn't work-in another six in there to make it the number of the beast alludes my right now, but I'm sure it was for a good cause. So, since I don't really have an album collection per se I'm gonna fire up iPhoto and see what comes up in hopes it's nothing bad. Worse case scenario is you get to see a bit too much of my girlfriend.`}</p>
    <p>{`I have no idea why anyone would want to look at this photo, but I guess it's a little bit funny.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/images/collection/60.jpg",
        "alt": null,
        "title": "WtfLol"
      }}></img></p>
    <p>{`Ok enough looking, she's mine ... I was supposed to tag more people, but I'll just tag the `}<a parentName="p" {...{
        "href": "http://3pike.blogspot.com/"
      }}>{`girlfriend`}</a>{`, because none of my contacts are cool enough to have personal blogs, just a bunch of stupid niche bloggers and nonbloggers.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      